var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCallRequest(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#D9D9D9",
    fillRule: "nonzero",
    d: "M18.641 17.655l-2.47-2.477c-.493-.49-1.308-.476-1.817.035l-1.245 1.247-.246-.137c-.786-.436-1.862-1.035-2.994-2.17-1.136-1.138-1.733-2.218-2.17-3.007-.046-.083-.09-.164-.134-.24l.836-.837.41-.412c.51-.511.524-1.328.033-1.82l-2.47-2.478c-.491-.492-1.307-.477-1.817.035l-.677.72a4.039 4.039 0 0 0-.574 1.015c-.134.354-.217.691-.256 1.03-.326 2.71.91 5.188 4.265 8.55 4.637 4.647 8.373 4.296 8.535 4.279a4.167 4.167 0 0 0 1.03-.26c.366-.143.71-.339 1.008-.572l.72-.679c.51-.511.524-1.328.033-1.822z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "nonzero",
    stroke: "#D9D9D9",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: "M19.596 8.44l.001-4.242-4.244-.002"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 7,
    height: 1,
    x: 12.561,
    y: 7.232,
    fill: "#EF4F23",
    stroke: "#D9D9D9",
    rx: 0.5,
    transform: "rotate(135 16.06 7.732)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCallRequest);
export default __webpack_public_path__ + "static/media/call-request.73d00755368e65a9f7176cede921be05.svg";
export { ForwardRef as ReactComponent };